<app-todo *ngIf="move.track.transferee.settingTheScene" [label]="i18nKeys.Todo | translate" [state]="todoState.Checked">
    <app-todo-template *todoStateChecked>
        <span>{{ move.track.lastModifiedOn.settingTheScene | formatDate }}</span>
    </app-todo-template>
</app-todo>
